import { createReducer } from 'redux-create-reducer'
import type { CampaignFooter } from 'types/content-editor'
import {
  CAMPAIGN_FOOTER_CREATE_SUCCESS,
  CAMPAIGN_FOOTER_DELETE_SUCCESS,
  CAMPAIGN_FOOTER_UPDATE_SUCCESS,
  CAMPAIGN_FOOTERS_LOAD,
  CAMPAIGN_FOOTERS_LOAD_FAIL,
  CAMPAIGN_FOOTERS_LOAD_SUCCESS,
} from '@disco/constants/ActionTypes'
import { updateItem } from '@disco/utils/immutable'
export type State = {
  items: CampaignFooter[]
  loaded: boolean
  loading: boolean
  saving: boolean
  error: string | null | undefined
}
const initialState: State = {
  items: [],
  error: null,
  loaded: false,
  loading: false,
  saving: false,
}
export const campaignFootersReducer = createReducer<State, any>(initialState, {
  [CAMPAIGN_FOOTERS_LOAD](state) {
    return { ...state, loading: true, loaded: false }
  },

  [CAMPAIGN_FOOTERS_LOAD_SUCCESS](state, { result }) {
    return { ...state, loading: false, loaded: true, items: result }
  },

  [CAMPAIGN_FOOTERS_LOAD_FAIL](state, { error }) {
    return { ...state, loading: false, loaded: false, items: [], error }
  },

  [CAMPAIGN_FOOTER_DELETE_SUCCESS](state, { id }) {
    return { ...state, items: state.items.filter(item => item.id !== id) }
  },

  [CAMPAIGN_FOOTER_UPDATE_SUCCESS](state, { id, result }) {
    const index = state.items.findIndex(item => item.id === id)
    return { ...state, items: updateItem(state.items, index, result) }
  },

  [CAMPAIGN_FOOTER_CREATE_SUCCESS](state, { result }) {
    return { ...state, items: [...state.items, result] }
  },
})
